<template>
    <div>
        <b-button v-if="size === 'small'" :disabled="isDisableSign" v-b-tooltip.hover title="Firma Grafometrica" size="sm" class="no-text" variant="outline-secondary" @click="onFirmaGrafometrica()">
            <b-icon icon="pencil-square"></b-icon>
            <!-- Firma Grafometrica -->
        </b-button>
        <b-button v-else :disabled="isDisableSign" v-b-tooltip.hover title="Firma Grafometrica" size="sm" variant="outline-secondary" @click="onFirmaGrafometrica()">
            <b-icon icon="pencil-square"></b-icon>
            <!-- Firma Grafometrica -->
        </b-button>
    </div>
</template>

<script>
import UtilityMixin from "../UtilityMixin";
export default {
    mixins: [UtilityMixin],
    props: {
        size: { type: String, default: "small" },
        jsonData: { type: Object },
    },
    data() {
        return {
            isDisableSign: false,
            pathResourceDocumentRepositoryLast: "/documentrepository/lastactive",
        };
    },
    methods: {
        onFirmaGrafometrica() {
            let me = this;
            this.loadDataResources(this.pathResourceDocumentRepositoryLast + "/" + me.jsonData.id, null, this.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadDocument", response.data.data);
        },
        onFirma() {},
    },
};
</script>

<style></style>
